import { inject, Injectable } from '@angular/core';
import { DialogService } from '@core/services/dialog.service';
import { LanguageDialogComponent } from './language-dialog.component';

@Injectable({ providedIn: 'root' })
export class LanguageDialogService {
  private dialogService = inject(DialogService);

  openLanguageDialog(): void {
    this.dialogService.open({
      size: 'sm',
      title: 'General.Language',
      contentComponent: LanguageDialogComponent,
      hideFooter: true,
    });
  }
}
